const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const authApiBaseUrl = process.env.REACT_APP_AUTH_API_BASE_URL;

if (!apiBaseUrl) {
    console.warn("REACT_APP_API_BASE_URL is not defined.");
}
if (!authApiBaseUrl) {
    console.warn("REACT_APP_AUTH_API_BASE_URL is not defined.");
}

export const API_ENDPOINTS = {
    MAIN: apiBaseUrl,
    AUTH: authApiBaseUrl,
};

export const getApiEndpoint = (service: keyof typeof API_ENDPOINTS, path: string): string => {
    const baseUrl = API_ENDPOINTS[service];
    if (!baseUrl) {
        throw new Error(`API base URL for service "${service}" is not defined.`);
    }
    return `${baseUrl}${path}`;
};
